(function () {
  'use strict';

  function initBuyItWith(root) {
    root.querySelectorAll('[data-buy-it-with]').forEach(function (btn) {
      if (btn.dataset.buyItWithInit) return;
      btn.dataset.buyItWithInit = 'true';

      btn.addEventListener('click', async function () {
        const variantId = parseInt(this.dataset.buyItWith, 10);
        if (!variantId) return;

        const label = this.querySelector('.button__label') || this;
        const originalText = label.textContent;

        this.disabled = true;
        label.textContent = 'Adding…';

        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }]
            })
          });

          if (response.ok) {
            label.textContent = 'Added ✓';
            setTimeout(() => {
              label.textContent = originalText;
              this.disabled = false;
            }, 2000);
          } else {
            const err = await response.json();
            label.textContent = err.description || 'Error';
            setTimeout(() => {
              label.textContent = originalText;
              this.disabled = false;
            }, 2500);
          }
        } catch (e) {
          label.textContent = originalText;
          this.disabled = false;
        }
      });
    });
  }

  // Init on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initBuyItWith(document);
    });
  } else {
    initBuyItWith(document);
  }

  // Re-init when cart drawer is updated (items added/removed)
  document.addEventListener('shopify:section:load', function (e) {
    initBuyItWith(e.target);
  });

  // Re-init after cart drawer re-renders (theme uses custom events)
  document.addEventListener('cart:updated', function () {
    initBuyItWith(document);
  });
})();
